export default __webpack_public_path__ + "static/Charles Osuji-9abfa23e8c08b8907d48046c154301c0.jpg";